import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/member',
  //   // name: 'member',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   // component: () => import(/* webpackChunkName: "about" */ '../views/MemberView.vue')
  //   redirect: {name:"member", params:{group:'EventGeneralCoordinator'}}
  // },
  // {
  //   path: '/member/:group',
  //   name: 'member',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/MemberView.vue'),
  // },
  // {
  //   path: '/member/EventGeneralCoordinator',
  //   name: 'member',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/MemberView.vue'),
  //   alias: ['/member']
  // },
  // {
  //   path: '/works',
  //   name: 'works',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/WorksView.vue')
  // },
  // {
  //   path: '/vote',
  //   name: 'vote',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/VoteView.vue')
  // },
  // // {
  // //   path: '/product',
  // //   name: 'product',
  // //   // route level code-splitting
  // //   // this generates a separate chunk (about.[hash].js) for this route
  // //   // which is lazy-loaded when the route is visited.
  // //   component: () => import(/* webpackChunkName: "about" */ '../views/ProductView.vue')
  // // },
  // {
  //   path: '/capturePic',
  //   name: 'capturePic',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   redirect: {name:"capturePic", params:{id:'noPic'}}
  // },
  // {
  //   path: '/capturePic/:id',
  //   name: 'capturePic',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/ImageView.vue')
  // }
]

const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  },

})

export default router
